"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const TargetContext_1 = tslib_1.__importDefault(require("./TargetContext"));
/**
 * Higher order component that injects the TargetContext as a prop
 *
 * @deprecated TargetContext is not needed anymore. Get the values directly instead by
 *
 * ```typescript
 *   import { getApiUrl, getTargetMeta } from "@mne-core/providers/Target";
 *   const apiUrl = getApiUrl();
 *   const { apiUrl, baseUrl, metaInfo, domain, env, ...} = getTargetMeta();
 *
 * ```
 *
 */
const withTarget = () => (Component) => {
    const EnhancedComponent = (props) => {
        return (React.createElement(TargetContext_1.default.Consumer, null, (targetCtx) => React.createElement(Component, { ...props, target: targetCtx })));
    };
    return EnhancedComponent;
};
exports.default = withTarget;
